module.exports = __webpack_public_path__ + "img/card-background-first.816fca84.png";